import Vue from 'vue';
import VueIziToast from 'vue-izitoast';

import 'izitoast/dist/css/iziToast.min.css';

export default () => {
    Vue.use(VueIziToast);
}
